import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformLoadshiftSiteStats } from './loadshift-site-stats.transformers';
import type { LoadshiftSiteStatsCollection } from './loadshift-site-stats.types';

export function loadshiftSiteStatsReducer(
  state: CollectionStateSlice<LoadshiftSiteStatsCollection> = {},
  action: CollectionActions<LoadshiftSiteStatsCollection>,
): CollectionStateSlice<LoadshiftSiteStatsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'loadshiftSiteStats') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<LoadshiftSiteStatsCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformLoadshiftSiteStats,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }
      break;
    }
    default: {
      return state;
    }
  }
  return state;
}
